import homeView from './index'
import searchView from './search'
import bookView from './book'

import model from './services/model'

export default {
  path: 'hotel',
  component: homeView,
  name: 'Private/Hotel',
  redirect: { name: 'Private/Hotel/Search' },
  children: [
    {
      path: 'search',
      component: searchView,
      name: 'Private/Hotel/Search'
    },
    {
      path: 'book/:Result/:Category/:Meal',
      component: bookView,
      name: 'Private/Hotel/Book'
    }
  ],
  beforeEnter (to, from, next) {
    if (!model.initDataLoaded) model.init().then(res => next())
    else next()
  }
}
